import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/element-ui-override.scss'
import router from './router'
import store from './store'
import * as echarts from 'echarts'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
